import React, { Component } from 'react';

// Public PayPal browser client ID and subscription plan supplied by Lenderblock.
// IMPORTANT: Checkout approval alone must never activate Pro Plus entitlements.
const PAYPAL_CLIENT_ID = 'BAASnPvsdBCOCr_kjw3xK_qRmO9_GGosWE80JB-61JT4Xx1UD31eiofrOzhPTZPfCXTYiDnZqJwqxSWrhU';
const PAYPAL_PLAN_ID = 'P-9MH4098189629840DNLQ4IZY';
const SDK_ID = 'tbp-paypal-subscriptions-sdk';

let sdkPromise;
function loadPayPal() {
  if (window.paypal && window.paypal.Buttons) return Promise.resolve(window.paypal);
  if (sdkPromise) return sdkPromise;
  sdkPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(SDK_ID);
    const script = existing || document.createElement('script');
    if (!existing) {
      script.id = SDK_ID;
      script.src = `https://www.paypal.com/sdk/js?client-id=${encodeURIComponent(PAYPAL_CLIENT_ID)}&vault=true&intent=subscription`;
      script.setAttribute('data-sdk-integration-source', 'button-factory');
      script.async = true;
      document.head.appendChild(script);
    }
    const onLoad = () => window.paypal && window.paypal.Buttons
      ? resolve(window.paypal)
      : reject(new Error('PayPal SDK did not initialize.'));
    const onError = () => reject(new Error('Could not load PayPal checkout.'));
    script.addEventListener('load', onLoad, { once: true });
    script.addEventListener('error', onError, { once: true });
  }).catch(error => { sdkPromise = null; throw error; });
  return sdkPromise;
}

class PayPalSubscribeButton extends Component {
  constructor(props) {
    super(props);
    this.container = React.createRef();
    this.mounted = false;
    this.state = { error: '', approvedId: '', linking: false, linked: false };
  }
  componentDidMount() {
    this.mounted = true;
    loadPayPal().then(paypal => {
      if (!this.mounted || !this.container.current) return;
      this.buttons = paypal.Buttons({
        style: { shape: 'pill', color: 'silver', layout: 'vertical', label: 'subscribe' },
        createSubscription: async (data, actions) => {
          if (typeof this.props.getAccountId !== 'function') throw new Error('Sign in before purchasing.');
          const accountId = await this.props.getAccountId();
          if (!/^[a-f0-9-]{36}$/i.test(String(accountId || ''))) throw new Error('Missing authenticated account ID.');
          // PayPal custom_id is for account association only. NEVER send Cognito JWTs to PayPal.
          return actions.subscription.create({ plan_id: PAYPAL_PLAN_ID, custom_id: accountId });
        },
        onApprove: async data => {
          const subscriptionId = data.subscriptionID;
          if (this.mounted) this.setState({ approvedId: subscriptionId || '', linking: true, error: '' });
          try {
            if (typeof this.props.onApproved !== 'function') throw new Error('Subscription verification is unavailable.');
            await this.props.onApproved(subscriptionId);
            if (this.mounted) this.setState({ linked: true });
          } catch (error) {
            if (this.mounted) this.setState({ error: error.message || 'Subscription verification is pending.' });
          } finally { if (this.mounted) this.setState({ linking: false }); }
        },
        onError: error => {
          if (this.mounted) this.setState({ error: 'PayPal checkout encountered an error. Please retry.' });
          console.error('PayPal subscription error:', error);
        }
      });
      if (this.buttons.isEligible()) return this.buttons.render(this.container.current);
      throw new Error('PayPal checkout is not available for this browser.');
    }).catch(error => {
      if (this.mounted) this.setState({ error: error.message });
    });
  }
  componentWillUnmount() {
    this.mounted = false;
    if (this.buttons && typeof this.buttons.close === 'function') this.buttons.close();
  }
  render() {
    const spanish = this.props.language === 'spanish';
    return (
      <div className="tbp-paypal-checkout" style={{ width:'100%', maxWidth:440, margin:'16px auto', textAlign:'center' }}>
        <div ref={this.container} />
        {this.state.error && <p role="alert" style={{ color:'#b3261e', fontSize:13 }}>{this.state.error}</p>}
        {this.state.approvedId && (
          <div role="status" style={{ padding:12, background:'#e7f8ec', border:'1px solid #b7e7c4', borderRadius:9, color:'#145a32', fontSize:13 }}>
            <strong>{this.state.linked ? (spanish ? 'Suscripción verificada.' : 'Subscription verified.') : (spanish ? 'PayPal aprobó el proceso.' : 'PayPal checkout approved.')}</strong>
            <div>{spanish ? 'ID de suscripción:' : 'Subscription ID:'} {this.state.approvedId}</div>
            <div>{this.state.linked ? (spanish ? 'Tu acceso Pro Plus está activo.' : 'Your Pro Plus membership is active.') : (spanish ? 'Verificando la suscripción con PayPal…' : 'Verifying your subscription with PayPal…')}</div>
          </div>
        )}
      </div>
    );
  }
}
export default PayPalSubscribeButton;
